<template>
  <section style="padding-top: 120px" class="payment-status">
    <v-container>
      <div class="status-wrapper">
        <div class="status-card success animate__animated animate__fadeInUp">
          <div class="card-bg-shape"></div>
          <div class="floating-shapes">
            <div class="triangle t1"></div>
            <div class="circle c1"></div>
            <div class="particle p1"></div>
            <div class="particle p2"></div>
          </div>
          <div class="icon-circle success-icon animate__animated animate__bounceIn">
            <i class="fas fa-check"></i>
          </div>
          <h2 class="status-title animate__animated animate__fadeInUp animate__delay-1s">
            Payment Successful!
          </h2>
          <p class="status-message animate__animated">
            Thank you for your payment. Your transaction has been completed successfully.
          </p>
          <p class="redirect-message animate__animated">
            Redirecting to home page in {{ countdown }} seconds...
          </p>
        </div>
      </div>
      <div class="bg-decorations">
        <div class="bg-circle bc1"></div>
        <div class="bg-triangle bt1"></div>
        <div class="bg-circle bc2"></div>
        <div class="bg-triangle bt2"></div>
        <div class="glow-dot gd1"></div>
        <div class="glow-dot gd2"></div>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'SuccessView',
  data() {
    return {
      countdown: 5,
      redirectTimer: null,
    };
  },
  mounted() {
    this.startCountdown();
  },
  beforeUnmount() {
    // Clear the timer if the component is destroyed before redirection
    clearTimeout(this.redirectTimer);
  },
  methods: {
    startCountdown() {
      // Start the redirection timer
      this.redirectTimer = setTimeout(() => {
        this.$router.push('/');
      }, 5000); // 5 seconds

      // Update the countdown display every second
      const interval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
/* All styles from the original component are included here */
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;900&display=swap');

.payment-status {
  background: #fff;
  padding: 50px 0;
  font-family: 'Nunito Sans', sans-serif;
  position: relative;
  overflow: hidden;
  min-height: 100vh; /* Ensure full viewport height */
}

.status-wrapper {
  text-align: center;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-card {
  max-width: 600px;
  margin: 0 auto 30px;
  padding: 50px 30px;
  border-radius: 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  transition: all 0.4s ease;
  transform-style: preserve-3d;
}

.status-card:hover {
  transform: translateY(-8px) scale(1.02) rotateX(1deg);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.status-card.success .status-title {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.icon-circle {
  font-size: 50px;
  margin-bottom: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 110px;
  height: 110px;
  border-radius: 50%;
  color: white;
  position: relative;
  box-shadow: 0 0 25px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
}

.success-icon {
  background: linear-gradient(135deg, #22c55e, #16a34a);
  box-shadow: 0 0 30px rgba(34, 197, 94, 0.5);
}

.icon-circle:hover {
  transform: scale(1.15) rotate(10deg);
}

.status-title {
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 12px;
  letter-spacing: -0.5px;
}

.status-message {
  font-size: 17px;
  color: #475569;
  margin-bottom: 15px;
}

.redirect-message {
  font-size: 15px;
  color: #f46523;
  font-weight: 600;
  margin-top: 15px;
}

/* Floating shapes (Success specific shapes are kept) */
.floating-shapes .triangle,
.floating-shapes .circle,
.floating-shapes .particle {
  position: absolute;
  opacity: 0.15;
}

.t1 {
  top: 20px;
  right: 40px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 35px solid #22c55e;
  animation: float 4s infinite ease-in-out;
}

.c1 {
  top: 50px;
  left: 50px;
  background: #22c55e;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  animation: float 6s infinite ease-in-out reverse;
}

.particle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #f46523;
  animation: float 7s infinite ease-in-out;
}

.p1 {
  top: 30%;
  left: 10%;
}

.p2 {
  bottom: 25%;
  right: 20%;
}

/* Background Decorations (Kept all) */
.bg-decorations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background: rgba(244, 101, 35, 0.05);
  animation: float 10s ease-in-out infinite;
}

.bc1 {
  top: 20%;
  right: 10%;
}
.bc2 {
  bottom: 25%;
  left: 12%;
  width: 120px;
  height: 120px;
  background: rgba(34, 197, 94, 0.05);
}

.bg-triangle {
  position: absolute;
  border-left: 60px solid transparent;
  border-right: 60px solid transparent;
  border-bottom: 100px solid rgba(244, 101, 35, 0.04);
  animation: float 12s ease-in-out infinite;
}

.bt1 {
  bottom: 15%;
  left: 5%;
}

.bt2 {
  top: 10%;
  left: 25%;
  border-bottom-color: rgba(239, 68, 68, 0.05);
}

/* Glow dots */
.glow-dot {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: rgba(255, 215, 0, 0.8);
  box-shadow:
    0 0 20px rgba(255, 215, 0, 0.8),
    0 0 40px rgba(255, 215, 0, 0.6);
  animation: pulseDot 3s infinite ease-in-out;
}

.gd1 {
  top: 30%;
  right: 18%;
}
.gd2 {
  bottom: 20%;
  left: 20%;
}

/* Keyframes */
@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes pulseDot {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.5);
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .status-title {
    font-size: 26px;
  }
  .icon-circle {
    width: 90px;
    height: 90px;
    font-size: 36px;
  }
}
</style>
